import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enPages from './locales/en/pages.json';

import deCommon from './locales/de/common.json';
import deNavigation from './locales/de/navigation.json';
import dePages from './locales/de/pages.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    pages: enPages,
  },
  de: {
    common: deCommon,
    navigation: deNavigation,
    pages: dePages,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'pages'],

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false, // Disable suspense for compatibility with older React
    },
  });

export default i18n;
